import script from "./Pf16.vue?vue&type=script&setup=true&lang=js"
export * from "./Pf16.vue?vue&type=script&setup=true&lang=js"

import "./Pf16.vue?vue&type=style&index=0&id=344f2188&scoped=true&lang=css"

import exportComponent from "/home/runner/work/tests-frontend/tests-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-344f2188"]])

export default __exports__